import type { XingletInterface } from '../xinglet-helpers';
import { XingletWrapper } from '../xinglet-helpers';

import type { TemplateProps } from '.';

export type TemplateBusinessProps = TemplateProps;
export type TemplateBusinessXinglet = XingletInterface<TemplateBusinessProps>;

export const Business = XingletWrapper<TemplateBusinessProps>(
  '@xing-com/crate-lebenslauf-templates-business'
);
